import React, { useEffect } from "react";
import Header from "../Components/Header.js";
import Hero from "../Components/Hero.js";
import Selectedprojects from "../Components/Selectedprojects.js";
import Aboutme from "../Components/Aboutme.js";
import Articles from "../Components/Articles.js";
import Contact from "../Components/Contact.js";
import Footer from "../Components/Footer.js";


const Home = () => {
  useEffect(() => {
    // Check if the hash in the URL matches any section ID
    const sectionId = window.location.hash.replace("#", ""); // Get the hash without the #
    if (sectionId) {
      const section = document.getElementById(sectionId); // Find the section by ID
      if (section) {
        section.scrollIntoView({ behavior: "smooth" }); // Scroll to the section smoothly
      }
    }
  }, []); // Empty dependency array to run this once on component mount
  
  return (
    <div className="home-container" id="home">
      <Header />
      <Hero />
      <Selectedprojects />
      <Aboutme id="about-me" />
      <Articles />
      <Contact id="contact-me"/>
      <Footer />
    </div>
  );
};

export default Home;

